import React from "react";

const Navdata = () => {
  const menuItems = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
    },
    {
      id: "realTime",
      label: "In Real Time",
      icon: "ri-briefcase-4-line",
      link: "/real-time",
      click: function (e) {
        e.preventDefault();
      },
    },
    {
      id: "tripList",
      label: "Trip List",
      icon: "ri-file-list-3-line",
      link: "/trip-list",
      click: function (e) {
        e.preventDefault();
      },
    },
    {
      id: "maintenance",
      label: "Maintenance & Insurance",
      icon: "ri-list-settings-line",
      link: "/maintenance",
      click: function (e) {
        e.preventDefault();
      },
    },
    {
      id: "vehicleManagement",
      label: "Vehicle Management",
      icon: "ri-taxi-wifi-line",
      link: "/vehicle-management",
      click: function (e) {
        e.preventDefault();
      },
    },
    {
      id: "userManagement",
      label: "User Management",
      icon: "ri-group-2-line",
      link: "/user-management",
      click: function (e) {
        e.preventDefault();
      },
    },
    {
      id: "driverManagement",
      label: "Driver Management",
      icon: "ri-user-3-line",
      link: "/driver-management",
      click: function (e) {
        e.preventDefault();
      },
    },
    {
      id: "userPermissions",
      label: "User Permissions",
      icon: "ri-user-follow-line",
      link: "/user-permissions",
      click: function (e) {
        e.preventDefault();
      },
    },
    {
      id: "salaryManagement",
      label: "Salary Management",
      icon: "ri-hand-coin-line",
      link: "/salary-management",
      click: function (e) {
        e.preventDefault();
      },
    },
    {
      id: "category",
      label: "Category Management",
      icon: "ri-stack-line",
      link: "/category",
      click: function (e) {
        e.preventDefault();
      },
    },
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
